module.exports = __webpack_public_path__ + "img/Status.da92659a.svg";